import { render, staticRenderFns } from "./CreateLeadForm.vue?vue&type=template&id=55e3a63e&"
import script from "./CreateLeadForm.vue?vue&type=script&lang=js&"
export * from "./CreateLeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports